import { createSlice } from "@reduxjs/toolkit";

import BaseHelper from "../../helper/BaseHelper";
import { violSearchDataCall } from "../../utils/services/searchService";
export const slice = createSlice({
  name: "search",
  initialState: {
    violVehicleSearchData: null,
    filter: {
      // start_date: moment().year() + "-01-01",
      // end_date: moment().year() + "-01-21",
    },
    isLoading: true,
  },

  reducers: {
    setFilter: (state, { payload }) => {
      // console.log(payload);
      state.filter = payload;
    },
    setLoading: (state, { payload }) => {
      // console.log(payload);
      state.isLoading = payload;
    },

    setViolVehicleSearchData: (state, { payload }) => {
      state.violVehicleSearchData = { ...payload }; // Create a new object reference
    },
  },
});

export const {
  setLoading,

  setViolVehicleSearchData,

  setFilter,
} = slice.actions;

export const violVehicleSearchDataFun =
  (data) => async (dispatch, getState) => {
    try {
      // console.log(data);
      const responseData = await violSearchDataCall(data);
      //  transport/route/list
      //console.log(responseData);
      dispatch(setLoading(true));
      if (responseData.status.code === 200) {
        //console.log(responseData.data);
        dispatch(setViolVehicleSearchData(responseData.data));
        dispatch(setLoading(false));
        // BaseHelper.nodifyFun(responseData.status.message, "success");
        // dispatch(setCompanyInspectionData(responseData.data));
      } else {
        dispatch(setLoading(false));
        // dispatch(setViolationOffenderClear());
        BaseHelper.nodifyFun(responseData.status.message, "error");
      }

      //console.log(alert);
    } catch (error) {
      dispatch(setLoading(false));
      // dispatch(setViolationOffenderClear());
      console.log(error);
    }
  };

export default slice.reducer;
